import React, { Component } from "react";
import axios from "../../../axios";
import Alert from "react-s-alert";
import qs from "qs";
import { SCHEDULE_UPDATE_STATUS } from "../endpoints";
import DropdownView from "./DropdownView";
import {SelectPanel, MultiSelect} from "@khanacademy/react-multi-select";
import CustomModal from "../../../components/CustomModal";

class WebSiswa extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dataSiswaRemed: [],
            dataSiswaAll: [],
            dataSisAll: [],
            dataExport   : [],
            dataExportNotE   : [],
            dataParticipant: [],
            exam_cat_id: 0,
            ratarata:0,
            pageCount: 0,
            currentPage: 0,
            isLoading: false,
            isButtonLoading: false,
            isModalShow: false,
            modalShow:false,
            examId:"",
            nama:"",
            participant_id:"",
            isRemed:false,
            partRemed : [],
            partNotWeb: [],
            siswaTidakBisaWeb:[]
        };

        this.toggleModal = this.toggleModal.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeStatus = this.handleChangeStatus.bind(this);
        this.handleSelectedChanged = this.handleSelectedChanged.bind(this);
        this.handleSelectedChangedWeb = this.handleSelectedChangedWeb.bind(this);
        this.submitSiswaRemed = this.submitSiswaRemed.bind(this);
        this.submitSiswaTidakUjianWeb = this.submitSiswaTidakUjianWeb.bind(this);

    }

    toggleModal() {
        this.setState({ isModalShow: !this.state.isModalShow });
    }

    handleSelectedChanged(partRemed) {
        this.setState({partRemed});
    }

    handleSelectedChangedWeb(partNotWeb) {
        this.setState({partNotWeb});
    }


    submitSiswaRemed(){
        this.setState({ isButtonLoading: true });

        const params = qs.stringify({
            examId:this.props.match.params.exam_id,
            userId:this.state.partRemed
        });

        axios({
            method: "post",
            url: "ujian/siswa/addweb?" + params
        })
            .then(response => {
                const result = response.data;
                if (result.success) {
                    this.setState({ isButtonLoading: false },()=>{
                        Alert.success(result.message);
                        this.loadData();
                        setTimeout(() => {
                            this.loadDataParti();
                        }, 300);
                    });
                } else {
                    if (Array.isArray(result.message)) {
                        result.text.map(item => {
                            Alert.error(item);
                            return true;
                        });
                    } else {
                        Alert.error(result.message);
                    }

                    this.setState({ isButtonLoading: false });
                }
            })
    }

    submitSiswaTidakUjianWeb(){
        this.setState({ isButtonLoading: true });

        const params = qs.stringify({
            examId:this.props.match.params.exam_id,
            userId:this.state.partNotWeb
        });

        axios({
            method: "post",
            url: "ujian/siswa/delweb?" + params
        })
            .then(response => {
                const result = response.data;
                if (result.success) {
                    this.setState({ isButtonLoading: false},()=>{
                        Alert.success(result.message);
                        this.loadData();
                        setTimeout(() => {
                            this.loadDataParti();
                        }, 300);
                    });
                } else {
                    if (Array.isArray(result.message)) {
                        result.text.map(item => {
                            Alert.error(item);
                            return true;
                        });
                    } else {
                        Alert.error(result.message);
                    }

                    this.setState({ isButtonLoading: false });
                }
            })
    }

    handleChange(event) {
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        const newState = {
            [name]: value
        }

        this.setState(
            newState
        )
    }

    handlePageClick(data) {
        let selected = data.selected; // zero based index

        this.setState({ currentPage: selected }, () => {
            this.loadData();
            setTimeout(() => {
                this.loadDataParti();
            }, 300);
        });
    }

    handleChangeStatus(exam_id, exam_status) {
        axios
            .post(SCHEDULE_UPDATE_STATUS, qs.stringify({ exam_id, exam_status }))
            .then(response => {
                this.loadData();
                setTimeout(() => {
                    this.loadDataParti();
                }, 300);
            })
            .catch(error => {
                console.log(error);
                Alert.error("Gagal terhubung ke server!");
            });
    }

    loadData() {
        this.setState({ isLoading: true });

        const params = qs.stringify({
            page: this.state.currentPage + 1,
            locale:"id",
            platform:"web",
            exam_id:this.props.match.params.exam_id,
            cari: this.state.nama,
            participant_id:this.state.participant_id
        });

        axios({
            method: "post",
            url: "ujian/siswa/web?" + params
        })

            .then(response => {
                const result = response.data;
                if (result.success === true) {
                    this.setState({
                        tanggal_ujian : result.data.exam_start_date,
                        waktu_ujian : result.data.exam_time_limit,
                        guru : result.data.user_nama,
                        mapel : result.data.mapel_nama,
                        dataSiswaRemed: result.data.userWeb,
                        dataSiswaAll: result.data.userAll,
                        isRemed: result.data.exam_parent > 0 ? true : false,
                        isLoading: false,
                    });
                } else {
                    Alert.error(result.message);
                    this.setState({ isLoading: false });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ isLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    loadDataParti(){
        this.setState({ isLoading: true });
        const params = qs.stringify({
            locale:"id",
            platform:"web",
            exam_id:this.props.match.params.exam_id
        });

        axios({
            method: "post",
            url: "exam/participant?" + params
        })
            .then(response => {
                const result = response.data;

                if (result.status === true) {
                    const dataParticipant = result.data.participant.map(item => ({
                        key: item.participant_id,
                        value: item.kelas_nama
                    }));

                    this.setState({
                        dataParticipant,
                        isLoading: false
                    });
                    this.checkSiswaDefaultWeb(dataParticipant, this.state.dataSiswaAll)
                } else {
                    Alert.error(result.text);
                    this.setState({ isLoading: false });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ isLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    checkSiswaDefaultWeb(dataParticipant, dataSiswaAll){
        let tempSiswaTidakBisaWeb = []
        dataParticipant.forEach(participant => {
            dataSiswaAll.forEach(siswa => {
                if (participant.value === siswa.kelas_nama) {
                    tempSiswaTidakBisaWeb.push(siswa)
                }
            });
        });
        this.setState({siswaTidakBisaWeb:tempSiswaTidakBisaWeb})
    }

    componentDidMount() {
        this.loadData();
        setTimeout(() => {
            this.loadDataParti();
        }, 300);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.participant_id !== this.state.participant_id || prevState.nama !== this.state.nama) {
            this.loadData()
            setTimeout(() => {
                this.loadDataParti();
            }, 300);
        }
    }

    render() {
        const dataSisAll = this.state.siswaTidakBisaWeb.map(item => ({
            value: item.user_id,
            label: item.user_nama+' - '+item.kelas_nama
        }));

        const dataSisAllWeb = this.state.dataSiswaRemed.map(item => ({
            value: item.user_id,
            label: item.user_nama+' - '+item.kelas_nama
        }));

        const {partRemed, partNotWeb} = this.state;

        return (
            <div>
                {/* <CustomModal
                    modalHeaderText="Hapus"
                    modalBodyText="Anda yakin ingin menghapus?"
                    modalSubmitText="Hapus"
                    handleSubmit={() => this.handleSubmitDeleteButton()}
                    toggleModal={this.toggleModal}
                    isShow={this.state.isModalShow}
                /> */}
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-header">
                                Detail Siswa Ujian Web
                            </div>
                            <div className="card-block">
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">Guru</label>
                                    <div className="col-md-10">
                                        {": "}<b>{this.state.guru}</b>{" "}
                                        {
                                            this.state.isRemed ? (
                                                <span className="badge badge-primary">Remedial</span>
                                            ): ""
                                        }
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">Mata pelajaran</label>
                                    <div className="col-md-10">
                                        {": "}<b>{this.state.mapel}</b>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">Tanggal ujian</label>
                                    <div className="col-md-10">
                                        {": "}<b>{this.state.tanggal_ujian}</b>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">Waktu ujian</label>
                                    <div className="col-md-10">
                                        {": "}<b>{this.state.waktu_ujian} menit</b>
                                    </div>
                                </div>

                                <br/><br/>
                                <div className="col-md-12 form-group row">
                                    <div className="col-md-6">
                                        <DropdownView
                                            handleChange={this.handleChange}
                                            stateName="participant_id"
                                            label="Pilih Kelas Peserta"
                                            disabled={this.props.mode === 'Edit' ? true : false}
                                            items={this.state.dataParticipant}
                                            value={this.state.participant_id}
                                        />
                                    </div>
                                    {/*<div className="col-md-6">
                                        <input
                                            name="nama"
                                            type="text"
                                            className="form-control"
                                            placeholder="Ketikkan Nama Pengguna..."
                                            value={this.state.nama}
                                            onChange={this.handleChange}
                                            autoFocus={true}
                                        />
                                    </div>*/}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="row col-md-12">
                    <div className="col-md-6">
                            <div className="card">
                                <div className="card-header">Data Siswa - Ujian Web
                                    <button
                                        className="btn btn-primary btn-sm float-right"
                                        disabled={this.state.isLoading && "disabled"}
                                        onClick={this.submitSiswaTidakUjianWeb}>
                                        {this.state.isLoading ? "Loading..." : "Simpan"}
                                    </button>
                                </div>
                                <div className="card-block">
                                    {this.state.isLoading ? (
                                        "Memuat Data..."
                                    ) : this.state.dataSiswaRemed.length === 0 ? (
                                        "Data Kosong..."
                                    ) : (
                                        // <div>
                                        //     <div className="card">
                                        //         <table className="table table-striped table-bordered animated fadeIn">
                                        //             <thead>
                                        //             <tr>
                                        //                 <th>NAMA SISWA</th>
                                        //                 <th>KELAS</th>
                                        //                 <th width={100}>STATUS</th>
                                        //             </tr>
                                        //             </thead>
                                        //             <tbody>
                                        //             {this.state.dataSiswaRemed.map(items => {
                                        //                 return (
                                        //                     <tr key={items.siswa_id}>
                                        //                         <td>{items.user_nama}</td>
                                        //                         <td>{items.kelas_nama}</td>
                                        //                         <td>
                                        //                             <button
                                        //                                 type="button"
                                        //                                 className="btn btn-danger btn-sm"
                                        //                                 onClick={() => {
                                        //                                     this.toggleModal();
                                        //                                     this.setState({ user_id: items.user_id });
                                        //                                 }} >
                                        //                                 Hapus
                                        //                             </button>
                                        //                         </td>
                                        //                     </tr>
                                        //                 );
                                        //             })}
                                        //             </tbody>
                                        //         </table>
                                        //     </div>
                                        // </div>
                                        <SelectPanel
                                            options={dataSisAllWeb}
                                            onSelectedChanged={this.handleSelectedChangedWeb}
                                            hasSelectAll
                                            focusIndex={1}
                                            selected={partNotWeb}
                                            disableSearch={false}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card">
                                <div className="card-header">Data Siswa - Tidak Bisa Ujian Web
                                    <button

                                        className="btn btn-primary btn-sm float-right"
                                        disabled={this.state.isButtonLoading && "disabled"}
                                        onClick={this.submitSiswaRemed}>
                                        {this.state.isButtonLoading ? "Loading..." : "Simpan"}
                                    </button>
                                </div>
                                <div className="card-block">
                                    {this.state.isLoading ? (
                                        "Memuat Data..."
                                    ) : this.state.siswaTidakBisaWeb.length === 0 ? (
                                        "Data Kosong..."
                                    ) : (
                                        <div>
                                            {/*<div className="card">
                                                <table className="table table-striped table-bordered animated fadeIn">
                                                    <thead>
                                                    <tr>
                                                        <th>NAMA SISWA</th>
                                                        <th>KELAS</th>
                                                        <th width={100}>STATUS</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {this.state.dataSiswaAll.map(items => {
                                                        return (
                                                            <tr key={items.user_id}>

                                                                <td>{items.user_nama}</td>
                                                                <td>{items.kelas_nama}</td>
                                                                <td>
                                                                    <button
                                                                        type="button"
                                                                        className={`btn btn-sm ${
                                                                            items.entry_status != null
                                                                                ? "btn-primary"
                                                                                : "btn-warning"
                                                                            }`}

                                                                    >
                                                                        {items.entry_status != null ? items.entry_status : 'uncorections'}
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                    </tbody>
                                                </table>
                                            </div>*/}

                                            <SelectPanel
                                                options={dataSisAll}
                                                onSelectedChanged={this.handleSelectedChanged}
                                                hasSelectAll
                                                focusIndex={1}
                                                selected={partRemed}
                                                disableSearch={false}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        );
    }
}

export default WebSiswa;



// WEBPACK FOOTER //
// ./src/views/Exam/Schedule/WebSiswa.js